import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS_IN_DESCRIPTION = 20;

const rowHasValue = row =>
  row &&
  typeof row === 'object' &&
  !Array.isArray(row) &&
  Object.values(row).some(value => typeof value === 'string' && value.trim());

const renderText = text =>
  richText(text, {
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_DESCRIPTION,
    longWordClass: css.longWord,
  });

const SectionCoachCareerExperienceMaybe = props => {
  const { roles, culturalExposure } = props;
  const roleRows = Array.isArray(roles) ? roles.filter(rowHasValue) : [];
  const culturalExposureRows = Array.isArray(culturalExposure)
    ? culturalExposure.filter(rowHasValue)
    : [];

  if (roleRows.length === 0 && culturalExposureRows.length === 0) {
    return null;
  }

  return (
    <div className={css.sectionDescription}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id="ListingPage.coachCareerExperienceRolesTitle" />
      </h2>
      {roleRows.length > 0 ? (
        <>
          <p className={css.sectionSubHeading}>
            <FormattedMessage id="ListingPage.coachCareerExperienceRolesSubHeading" />
          </p>
          <ul className={css.structuredList}>
            {roleRows.map((row, index) => {
              const line = [row.jobTitle, row.company, row.dates].filter(Boolean).join(', ');
              return (
                <li className={css.structuredListItem} key={`${line}-${index}`}>
                  {line ? <div>{renderText(line)}</div> : null}
                </li>
              );
            })}
          </ul>
        </>
      ) : null}
      {culturalExposureRows.length > 0 ? (
        <>
          <p className={css.sectionSubHeading}>
            <FormattedMessage id="ListingPage.coachCareerExperienceCulturalExposureTitle" />
          </p>
          <ul className={css.structuredList}>
            {culturalExposureRows.map((row, index) => {
              const line = [row.countryRegion, row.dates].filter(Boolean).join(', ');
              return (
                <li className={css.structuredListItem} key={`${line}-${index}`}>
                  {line ? <div>{renderText(line)}</div> : null}
                </li>
              );
            })}
          </ul>
        </>
      ) : null}
    </div>
  );
};

SectionCoachCareerExperienceMaybe.defaultProps = {
  roles: [],
  culturalExposure: [],
};

SectionCoachCareerExperienceMaybe.propTypes = {
  roles: arrayOf(
    shape({
      jobTitle: string,
      company: string,
      dates: string,
    })
  ),
  culturalExposure: arrayOf(
    shape({
      countryRegion: string,
      dates: string,
    })
  ),
};

export default SectionCoachCareerExperienceMaybe;
